"use strict";
angular.module("planCommandMonitorBeforeSelectTopicCompileModule", [])
    .controller('planCommandMonitorBeforeSelectTopicCompileCtrl', ['$scope', "trsHttpService", "$q", '$stateParams', 'modalDialog','$modalInstance', 'itemData','$state', '$validation',
        function($scope, trsHttpService, $q, $stateParams, modalDialog, $modalInstance,itemData, $state, $validation) {
            initStatus();
            initData();

            /**
             * [initData description:初始化数据]
             */
            function initData() {
                requestData().then(function() {
                    requestGruop();
                });
            }
            /**
             * [initStatus description:初始化状态]
             */
            function initStatus() {
                $scope.status = {
                    id: '',
                    modelTitle: '添加'
                };
                if (angular.isDefined(itemData.datas)) {
                    $scope.status.id = itemData.datas.id;
                    $scope.status.modelTitle = itemData.datas.id ? "编辑" : "添加";
                }
                $scope.data = {
                    vtitle: '',
                    selectAll: false,
                    items: [],
                    selectedArray: [] //已选
                };
            }
            /*
             *[requestData description:获取数据]
             */
            function requestData() {
                var defer = $q.defer();
                var params = {
                    "serviceid": 'mlf_bigdatascreen',
                    "methodname": 'queryDataFromBigScreen',
                    "modalname": 'preSelectedMgr',
                    "method": 'getAllGroups'
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                    $scope.compileList = data;
                    $scope.data.items=$scope.compileList;
                    $scope.data.compileList = data;
                    defer.resolve();
                });
                return defer.promise;
            }
            /**
             * [requestGruop description:当是编辑状态下的]
             * @return {[type]} [description]
             */
            function requestGruop() {
                if (itemData.datas !== undefined) {
                    $scope.data.vtitle = itemData.datas.title;
                    var gruopParams = {
                        "serviceid": 'mlf_bigdatascreen',
                        "methodname": 'queryDataFromBigScreen',
                        "modalname": 'preSelectedMgr',
                        "method": 'getSelectedGroups',
                        'preselected_title_id': itemData.datas.id
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), gruopParams, 'post').then(function(data) {
                        //比对全部组 并对比已有组 在全部组中找到已有组
                        for (var i = 0; i < $scope.compileList.length; i++) {
                            var obj = $scope.compileList[i];
                            for (var j = 0; j < data.length; j++) {
                                if (obj.NEWGROUPID === data[j].NEWGROUPID) {
                                    $scope.data.selectedArray.push(data[j]);
                                    obj.STATE = '1';
                                }
                            }
                        }
                    });
                }
            }
            /**
             * [selectTopicComOrAdd description:编辑编前选题]
             * @return {[type]} [description]
             */
            $scope.selectTopicComOrAdd = function() {
                filtrate();
                $validation.validate($scope.beforeSelectTopicCmp)
                    .success(function() {
                        if ($scope.selectChars.length != 0) {
                            var comParams = {
                                "serviceid": 'mlf_bigdatascreen',
                                "methodname": 'queryDataFromBigScreen',
                                "modalname": 'preSelectedAddEdit',
                                "method": 'addSelectedGroup',
                                'preselected_title_id': $scope.status.id,
                                'preselected_title': $scope.data.vtitle,
                                "selected_groupids": $scope.selectChars
                            };
                            // console.log(comParams);
                            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), comParams, 'post').then(function(data) {
                                modalDialog.alertType("保存成功", "", "success", false, function() {
                                    $modalInstance.close();
                                    $scope.$emit("beforeSelectTop",{});
                                });
                            });
                        } else {
                            modalDialog.alertType('提示信息', '分组选择是必须的!','info','confirm',
                                function() {

                                });
                        }
                    })
                    .error(function() {
                        modalDialog.alertType('提示信息', '标题是必填!','info','confirm',
                            function() {

                            });
                    });

            };
            /**
             * [switchCheck description；选择框的选择状态]
             * @param  {[type]} group [description]
             * @return {[type]}       [description]
             */
            // $scope.switchCheck = function(group) {
            //     if (group.STATE === '0') {
            //         group.STATE = '1';
            //         // console.log(group.STATE);
            //     } else {
            //         group.STATE = '0';
            //     }
            // };
            /**
             * [selectAll description:全选]
             */
            $scope.selectAll = function () {
                $scope.groups = $scope.compileList;
                var groups = $scope.groups;
                $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
                if ($scope.data.selectedArray.length == $scope.data.items.length) {
                    angular.forEach(groups, function (group) {
                        group.STATE = '1';
                    });
                }
                if ($scope.data.selectedArray == '') {
                    angular.forEach(groups, function (group) {
                        group.STATE = '0';
                    });
                }
            };
            /**
             * [selectDoc 单选]
             * @param  {[type]} item [description：单个对象]
             */
            $scope.selectDoc = function(item) {
                if (item.STATE === '0') {
                    item.STATE = '1';
                } else {
                    item.STATE = '0';
                }
                if ($scope.data.selectedArray.indexOf(item) < 0) {
                    $scope.data.selectedArray.push(item);
                } else {
                    $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
                }
            };
            /**
             * [checkAllGroup description:全选按钮的状态选择]
             * @param  {[type]} group [description]
             * @return {[type]}       [description]
             */
            // $scope.checkAllGroup = function() {
            //     $scope.groups = $scope.compileList;
            //     var groups = $scope.groups;
            //     angular.forEach(groups, function(group) {
            //         group.STATE = '1';
            //     });
            // };
            /**
             * [invertSelect description:完成反选功能]
             * @return {[type]} [description]
             */
            // $scope.invertSelect = function() {
            //     $scope.groups = $scope.compileList;
            //     var groups = $scope.groups;
            //     angular.forEach(groups, function(group) {
            //         if (group.STATE === '0') {
            //             group.STATE = '1';
            //         } else {
            //             group.STATE = '0';
            //         }
            //     });
            // };
            /**
             * [filtrate description:筛选出被选中的分组]
             * @return {[type]} [description]
             */
            function filtrate() {
                $scope.groups3 = $scope.compileList;
                var selectList = [];
                angular.forEach($scope.groups3, function(group) {
                    if (group.STATE === "1") {
                        selectList.push(group.NEWGROUPID);
                    }
                });
                $scope.selectChars = selectList.join(",");
            }
            $scope.cancel=function(){
                $modalInstance.dismiss();
            };
            $scope.close=function(){
                $modalInstance.dismiss();
            };
        }
    ]);